import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Informes, InformesSearch, FiltroInformeContabilidadConsultas, InformeContabilidadConsultas, InformeConsultas } from '../../model/informes';
import { map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { MassiveLoadResult } from '../../model/massive-load-result';


@Injectable()
export class InformesService {
  validateFile(templateId: any, file: File) {
    throw new Error('Method not implemented.');
  }

  PATH = '';
  PATH_TIPOS = '';
  PATH_VAL_MASIVA = '';
  PATH_CARGAR_MASIVA = '';

  constructor(
    private http: HttpClient,
    private translatorService: TranslateService) {
    this.PATH = environment.API_BASE + '/Informes';
    this.PATH_VAL_MASIVA = environment.API_BASE + '/Informes/ValidarFicheroActualizacionContenidoMas';
    this.PATH_CARGAR_MASIVA = environment.API_BASE + '/Informes/CargarFicheroActualizacionContenidoMas';
  }

  getvalidateFileActMasCon( file: File): Observable<string> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<any>(this.PATH_VAL_MASIVA, formData);
  }
  
  getcargarFileActMasCon( file: File, check: boolean): Observable<string> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<any>(this.PATH_CARGAR_MASIVA + '/' + check , formData);
  }

  // Coge todos los informes disponibles
  getAllInformes(filters: InformesSearch): Observable<Informes[]> {
    return this.http.post<Informes[]>(this.PATH + '/Find', filters);
  }

  getAutogenerateReport(reportId: number): Observable<any> {
    return this.http.get(this.PATH + '/' + reportId, { responseType: 'blob' });
  }

  getInformeContabilidadConsultas(filtro: FiltroInformeContabilidadConsultas, desde: number = 0, size: number = 10): Observable<InformeConsultas> {
    const llamada = this.PATH + '/GetInformeContabilidadConsultas?from=' + desde + '&size=' + size;
    return this.http.post<InformeConsultas>(llamada, JSON.stringify(filtro), {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    }).pipe(map((r: InformeConsultas) => {
      r.CANTIDAD_AGRUPADA.forEach(_ => {
        _.name = this.translatorService.instant('informes.' + _.name);
      });
      return r;
    }));
  }

}
